import React from "react";
import { Tooltip } from "antd";
import { Localize } from "components/service";
import { buildCommunicationOrderPreview } from "../helpers/communication-preview-helper";
import type { TCommunicationTask } from "../helpers/communication-types-helper";

interface ICommunicationChangesFieldProps {
  task: TCommunicationTask;
}

const CommunicationChangesField: React.FC<ICommunicationChangesFieldProps> = ({ task }) => {
  const allOrderPreview = buildCommunicationOrderPreview(task);
  const visibleOrderPreview = allOrderPreview.slice(0, 2);
  const hiddenCount = Math.max(0, allOrderPreview.length - visibleOrderPreview.length);

  return (
    <div className="communication-changes-field">
      {allOrderPreview.length ? (
        <>
          <div className="communication-changes-field__summary">
            <span className="communication-changes-field__count">
              <Localize count={allOrderPreview.length}>COMMUNICATION.Text_ChangesCount</Localize>
            </span>
            {hiddenCount > 0 && (
              <span className="communication-changes-field__more">
                <Localize count={hiddenCount}>COMMUNICATION.Text_ChangesMore</Localize>
              </span>
            )}
          </div>

          {visibleOrderPreview.map((line) => (
            <Tooltip key={line.id} title={line.text}>
              <div className="communication-changes-field__line">
                {line.text}
              </div>
            </Tooltip>
          ))}
        </>
      ) : (
        <span className="communication-changes-field__empty">&mdash;</span>
      )}
    </div>
  );
};

export default CommunicationChangesField;
